import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { SitePage } from "../../Models/SitePage";
import PaginatedTable from "../Common/PaginatedTable";
import React from "react";
import { Link } from "react-router-dom";
import { HiDocumentDuplicate, HiEye, HiPencilAlt, HiXCircle } from "react-icons/hi";
import { Button, Tooltip } from "flowbite-react";
import { useAppSelector } from "../../Reducers/store";
import { UserLevelNames } from "../../Models/UserLevel";
import { SitePageListDto } from "../../Models/SitePageListDto";

export default function SitePagesList({
  data,
  setSelectedSitePage,
  setShowSitePage,
  accessCheck,
  deleteFile,
  onCopyPage,
}: {
  data: SitePageListDto[];
  setSelectedSitePage: React.Dispatch<React.SetStateAction<number | null>>;
  setShowSitePage: React.Dispatch<React.SetStateAction<boolean>>;
  accessCheck: boolean;
  deleteFile: (id: number) => void;
  onCopyPage?: (row: SitePageListDto) => void;
}) {
  const editSitePage = (value: number) => {
    setSelectedSitePage(value);
    setShowSitePage(true);
  };

  const { userModel } = useAppSelector((state) => state.user);

  const columnHelper = createColumnHelper<SitePageListDto>();

  const columns = [
    columnHelper.accessor((row) => row.id, {
      id: "id",
      header: "",
      cell: (info) => (
        <div className="flex justify-center">
          <Link to={`/page/${info.getValue()}`} className="buttonMain p-2">
            <Tooltip content="View Page">
              <HiEye></HiEye>
            </Tooltip>
          </Link>
          {accessCheck && (
            <Tooltip content="Edit Page">
              <Button
                onClick={() => {
                  editSitePage(info.getValue());
                }}
                className="buttonMain p-2"
                size={20}
              >
                <HiPencilAlt></HiPencilAlt>
              </Button>
            </Tooltip>
          )}
          {accessCheck &&
            onCopyPage &&
            userModel?.userLevelId === UserLevelNames.SuperAdmin &&
            !info.row.original.memberId && (
              <Tooltip content="Copy Page">
                <Button
                  onClick={() => onCopyPage(info.row.original)}
                  className="buttonMain p-2"
                  size={20}
                >
                  <HiDocumentDuplicate />
                </Button>
              </Tooltip>
            )}
          {accessCheck &&
            userModel?.userLevelId === UserLevelNames.SuperAdmin &&
            info.row.original.memberId != null &&
            info.row.original.memberId > 0 && (
              <Tooltip content="Member pages cannot be copied">
                <span className="inline-block p-2 text-gray-300 cursor-not-allowed">
                  <HiDocumentDuplicate />
                </span>
              </Tooltip>
            )}
        </div>
      ),
      footer: (info) => info.column.id,
      size: 80,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.title, {
      id: "title",
      header: "Title",
      footer: (info) => info.column.id,
    }),
    // columnHelper.accessor((row) => row.header, {
    //   id: "header",
    //   header: "Header",
    //   footer: (info) => info.column.id,
    // }),
    columnHelper.accessor((row) => row.pageType, {
      id: "PageType",
      header: "Page Type",
      cell: (info) => (
        <i>{info.getValue() ? info.row.original.pageType : ""}</i>
      ),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor((row) => row.id, {
      id: "delete",
      header: "",
      cell: (info) => (
        <div className="flex justify-center">
          {userModel?.userLevelId === UserLevelNames.SuperAdmin && (
            <Tooltip content="Delete">
              <button
                className="buttonCancel p-2"
                onClick={() => deleteFile(info.getValue())}
              >
                <HiXCircle size={20} />
              </button>
            </Tooltip>
          )}
        </div>
      ),
      footer: (info) => info.column.id,
      size: 50,
      enableColumnFilter: false,
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
    },
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });
  return (
    <>
      <div className="w-full mx-auto overflow-x-auto">
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode="onChange"
          showFilters={true}
        />
      </div>
    </>
  );
}
